// export * from './shared';
export * from './product-configurator.component';
